/**
 * `cn` — composable className helper. Combines clsx for conditional joins
 * with tailwind-merge for conflict resolution (so later "p-4" wins over
 * earlier "p-2", etc.).
 */
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
